export default "__VITE_ASSET__pcKYCGj1__"